import { render, staticRenderFns } from "./TermsAndConditionsView.vue?vue&type=template&id=433bee7c&scoped=true"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsView.vue?vue&type=style&index=0&id=433bee7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bee7c",
  null
  
)

export default component.exports